import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { EstadoRaiz, DespachoApp } from '../armazenamento/store';

/**
 * Hooks tipados para Redux
 *
 * useAppDispatch - dispatch tipado com suporte a thunks
 * useAppSelector - selector tipado com EstadoRaiz
 */
export const useAppDispatch: () => DespachoApp = useDispatch;
export const useAppSelector: TypedUseSelectorHook<EstadoRaiz> = useSelector;
